import { createIcon } from './icon';

export const PlayIcon = createIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M8 5v14l11-7z" />
  </svg>,
  'PlayIcon'
);
